import React from 'react'
import { motion } from 'framer-motion'
import ProfileBadge from './ProfileBadge'
import Navigation from './Navigation'

function PageHeader({
  showNav = true,
  onNavigateHome
}) {
  return (
    <>
      <motion.div layout className="px-4 -mx-4">
        <ProfileBadge onClick={onNavigateHome} />
      </motion.div>

      {showNav && (
        <div className="mt-4 mb-6 sm:mt-6 sm:mb-8">
          <Navigation layout="vertical" />
        </div>
      )}
    </>
  )
}

export default PageHeader
